// extracted by mini-css-extract-plugin
module.exports = {"step_footer_main":"StepFooter_step_footer_main__7vds0","container_border":"StepFooter_container_border__NzT1o"};